module.exports = __webpack_public_path__ + "static/media/confacts.b038374f.jpg";